
//#region src/types/model/sliceZone.ts
/**
* Type identifier for a Slice.
*
* More details: {@link https://prismic.io/docs/slice}
*/
const CustomTypeModelSliceType = {
	Slice: "Slice",
	SharedSlice: "SharedSlice"
};

//#endregion
exports.CustomTypeModelSliceType = CustomTypeModelSliceType;
//# sourceMappingURL=sliceZone.cjs.map